const theme = {
  warning: 'orange',
  error: 'red',
  success: 'limegreen'
}

export default theme
